<template>
  <div :class="`${classVariableName}-panel`">
    <div :class="`${classVariableName}-panel-content`">
      <div :class="`${classVariableName}-panel-content-header`">
        <div v-if="isMobile">
          <svg @click="closeModal" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M11.8315 5.88683C12.1237 6.18035 12.1227 6.65522 11.8292 6.94749L7.06555 11.6906H20.2502L20.352 11.6974C20.718 11.7471 21.0002 12.0609 21.0002 12.4406C21.0002 12.8548 20.6644 13.1906 20.2502 13.1906H7.06711L11.8292 17.9336L11.902 18.0176C12.1205 18.3107 12.0971 18.7274 11.8314 18.9942C11.5391 19.2877 11.0643 19.2887 10.7708 18.9964L4.73566 12.9863C4.62807 12.8848 4.55049 12.7518 4.51763 12.6021C4.46428 12.36 4.53201 12.0965 4.72081 11.9085L10.7708 5.88454L10.8551 5.81211C11.1492 5.59489 11.5658 5.61999 11.8315 5.88683Z" fill="#211A1E"/>
          </svg>
        </div>
        <slot name="modalTitle"></slot>
        <div v-if="!isMobile">
          <svg @click="closeModal" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clip-path="url(#clip0_682_140575)">
              <path d="M19 4.99902L3.44365 20.5554" stroke="#211A1E" stroke-width="1.2" stroke-linecap="round"/>
              <path d="M19 19.999L3.44365 4.44267" stroke="#211A1E" stroke-width="1.2" stroke-linecap="round"/>
            </g>
            <defs>
              <clipPath id="clip0_682_140575">
                <rect width="24" height="24" fill="white" transform="translate(0 -0.000976562)"/>
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <div :class="`${classVariableName}-panel-body`">
        <slot name="default"></slot>
      </div>

      <div
        v-if="!isEmpty(ctaTitle)"
        :class="`${classVariableName}-panel-footer-container`"
      >
        <!-- <div
          v-if="helperText"
          :class="`${classVariableName}-panel-footer-helper`"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="1.66591"
              cy="1.66591"
              r="1.26591"
              transform="matrix(0.706786 0.707427 -0.706786 0.707427 13.5156 4.12695)"
              stroke="#008945"
              stroke-width="0.8"
            />
            <path
              d="M14.4956 10.1151C13.9442 9.83385 13.318 9.73458 12.7068 9.83148C12.0956 9.92837 11.5306 10.2165 11.093 10.6545"
              stroke="#008945"
              stroke-width="0.8"
              stroke-linecap="round"
            />
            <path
              d="M9.88844 5.50352C10.1694 6.05542 10.2686 6.68219 10.1718 7.29399C10.075 7.90578 9.78712 8.47119 9.34952 8.90919"
              stroke="#008945"
              stroke-width="0.8"
              stroke-linecap="round"
            />
            <circle
              cx="1.66591"
              cy="1.66591"
              r="1.26591"
              transform="matrix(0.706786 0.707427 -0.706786 0.707427 6.45312 2.94922)"
              stroke="#008945"
              stroke-width="0.8"
            />
            <circle
              cx="1.66591"
              cy="1.66591"
              r="1.26591"
              transform="matrix(0.706786 0.707427 -0.706786 0.707427 14.6953 11.1973)"
              stroke="#008945"
              stroke-width="0.8"
            />
            <path
              d="M3.22247 16.0015L5.83214 8.89278C5.98319 8.48133 6.51007 8.36542 6.81985 8.67548L11.3455 13.2052C11.656 13.516 11.5382 14.0442 11.125 14.1935L3.98967 16.7726C3.51022 16.9459 3.04679 16.4801 3.22247 16.0015Z"
              stroke="#008945"
              stroke-width="0.8"
            />
            <path
              d="M5.3516 10.871L9.16663 14.6896"
              stroke="#008945"
              stroke-width="0.8"
              stroke-linecap="round"
            />
          </svg>
          Write a review
        </div> -->
        <div
          v-if="!isEmpty(ctaTitle)"
          :class="`${classVariableName}-panel-footer`"
        >
          <button
            :class="`${classVariableName}-panel-footer-button-primary`"
            :disabled="ctaActionDisabled"
            @click="ctaAction"
            :style="{ width: '360px' }"
          >
            {{ ctaTitle }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { classVariableName, isEmpty } from "../../utils";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  mounted() {},
  data() {
    return {
      classVariableName: classVariableName,
    };
  },
  props: {
    modalTitle: {
      type: String,
      required: false,
      default: "",
    },
    ctaTitle: String,
    helperText: Boolean,
    ctaAction: Function,
    ctaActionDisabled: Boolean,
    closeModal: Function,
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 430;
    },
  },
  methods: {
    isEmpty(val) {
      return isEmpty(val);
    },
    closeOnClickOutside(event) {
      if (event.target === this.$el) {
        this.closeModal();
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import "../../assets/SidePanel.scss";
</style>
